<div class="flexyoo-login-as-form">
  <div class="flexyoo-login-as-form__title">{{ 'auth.hello' | translate }} {{ userName }}</div>
  <div class="flexyoo-login-as-form__description">{{ 'auth.choose-role' | translate }}</div>
  <div class="user-roles-list">
    @for (role of sortedRoles; track role) {
      <div class="role-container">
        <div class="login-icon-container">
          <mat-icon>person</mat-icon>
        </div>
        <button class="login-as fo-color-secondary" matButton="filled" (click)="onRoleSelected(role)">
          {{ getRoleTranslation(role) | translate }}
        </button>
      </div>
    }
  </div>
</div>
